import React from 'react';
import PropTypes from 'prop-types';
import { useT } from 'client/i18n/hooks/useT';
import styles from './TypeaheadOption.sass';

const TypeaheadOption = ({ image, podcastName, authorName }) => {
  const t = useT();
  return (
    <div className={styles.typeaheadResult}>
      <img
        src={image}
        height={80}
        width={80}
        alt={t(
          'ImportScreen.ImportSection.TypeaheadOption.ImageAlt',
          'Cover for the podcast {podcastName}',
          'Podcast cover search result entry image screenreader information',
          { podcastName }
        )}
      />
      <div>
        <h5>{podcastName}</h5>
        <p>{authorName}</p>
      </div>
    </div>
  );
};

TypeaheadOption.propTypes = {
  image: PropTypes.string.isRequired,
  podcastName: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
};

export default TypeaheadOption;
